import { useState, useEffect } from "react";
import { getReviewByEntity, ReviewRequestDTO } from "../../data/api/reviewsApi";

/**
 * Hook to get review status for an entity
 * @param entityType - Entity type (journal, bill, invoice, credit_note, debit_note)
 * @param entityId - Entity ID
 * @returns Review status and helper flags
 */
export const useEntityReviewStatus = (
  entityType: string | null,
  entityId: number | null
) => {
  const [review, setReview] = useState<ReviewRequestDTO | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!entityType || !entityId) {
      setReview(null);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchReview = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getReviewByEntity(entityType, entityId);
        console.log("response for getReviewByEntity", response);
        setReview(response.data.review);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to fetch review")
        );
        console.error("Error fetching review:", err);
        setReview(null);
      } finally {
        setLoading(false);
      }
    };

    fetchReview();
  }, [entityType, entityId]);

  const status = review?.status || null;
  const hasPendingReview = status === "pending";
  const hasRejectedReview = status === "rejected";
  const hasApprovedReview = status === "approved";

  return {
    review,
    status,
    loading,
    error,
    hasPendingReview,
    hasRejectedReview,
    hasApprovedReview,
  };
};
